import {
  ReminderSettingsServiceTimingFragment,
  ServiceReminderTimingOffsetUnit,
  ServiceReminderTimingType,
} from 'shared/types/graphql';
import { compareAsc, addDays, addWeeks, addMonths, subDays, subWeeks, subMonths } from 'date-fns';

const dateFrom = (date: Date, timing: ReminderSettingsServiceTimingFragment): Date => {
  let func;
  if (timing.timingType === ServiceReminderTimingType.BeforeDue) {
    if (timing.offsetUnit === ServiceReminderTimingOffsetUnit.Months) {
      func = subMonths;
    } else if (timing.offsetUnit === ServiceReminderTimingOffsetUnit.Weeks) {
      func = subWeeks;
    } else {
      func = subDays;
    }
  } else {
    if (timing.offsetUnit === ServiceReminderTimingOffsetUnit.Months) {
      func = addMonths;
    } else if (timing.offsetUnit === ServiceReminderTimingOffsetUnit.Weeks) {
      func = addWeeks;
    } else {
      func = addDays;
    }
  }
  return func(date, timing.offset);
};

/**
 * Sort reminders by:
 *  timing type: before then after
 *  offset unit: months then weeks then days
 *  offset
 *  hourOfDay
 *  minuteOfHour
 */
export const comparator = (
  a: ReminderSettingsServiceTimingFragment,
  b: ReminderSettingsServiceTimingFragment,
): number => {
  const now = new Date();
  const compare = compareAsc(dateFrom(now, a), dateFrom(now, b));
  if (compare !== 0) return compare;
  if (a.hourOfDay !== b.hourOfDay) return b.hourOfDay - a.hourOfDay;
  return b.minuteOfHour - a.minuteOfHour;
};
